import { BrandConfig } from './brandConfig';
import countryOptions from './countryOptions';

const zandvoortConfig: BrandConfig = {
    contactUrl: 'https://www.visitzandvoort.nl/contact',
    countryOptions,
};

export default zandvoortConfig;
